import {mergeProps as $7CUUz$mergeProps, filterDOMProps as $7CUUz$filterDOMProps} from "@react-aria/utils";
import {useFocusable as $7CUUz$useFocusable} from "@react-aria/focus";
import {usePress as $7CUUz$usePress} from "@react-aria/interactions";




function $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, ref) {
    let { isDisabled: isDisabled = false , isRequired: isRequired , isReadOnly: isReadOnly , value: value , name: name , children: children , 'aria-label': ariaLabel , 'aria-labelledby': ariaLabelledby , validationState: validationState = 'valid'  } = props;
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected(e.target.checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn('If you do not provide children, you must specify an aria-label for accessibility');
    // This handles focusing the input on pointer down, which Safari does not do by default.
    let { pressProps: pressProps  } = $7CUUz$usePress({
        isDisabled: isDisabled
    });
    let { focusableProps: focusableProps  } = $7CUUz$useFocusable(props, ref);
    let interactions = $7CUUz$mergeProps(pressProps, focusableProps);
    let domProps = $7CUUz$filterDOMProps(props, {
        labelable: true
    });
    return {
        inputProps: $7CUUz$mergeProps(domProps, {
            'aria-invalid': validationState === 'invalid' || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-controls': props['aria-controls'],
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            onChange: onChange,
            disabled: isDisabled,
            ...value == null ? {
            } : {
                value: value
            },
            name: name,
            type: 'checkbox',
            ...interactions
        })
    };
}




export {$d2c8e2b0480f3f34$export$cbe85ee05b554577 as useToggle};
//# sourceMappingURL=module.js.map
